// extracted by mini-css-extract-plugin
export var list = "UrgentNews-module--list--Ora7S";
export var nomore = "UrgentNews-module--nomore--FrigA";
export var root = "UrgentNews-module--root--Omvsl";